import { Pipe, PipeTransform } from '@angular/core';

/**
 * NEO-4030 Milestone 7: wraps every case-insensitive match of `term` in `value` with `<mark>`.
 *
 * The output is meant for `[innerHTML]`, and `value` is user input (form submission answers), so the
 * whole string is HTML-escaped FIRST and only then are the matches wrapped. Matching runs on the raw
 * text and each segment is escaped on its own, so a search for `&` or `<` never matches inside an
 * entity we produced (`&amp;`, `&lt;`) and can never split one.
 */
@Pipe({
  name: 'highlight',
  standalone: true
})
export class HighlightPipe implements PipeTransform {

  public transform(value: string | number | null | undefined, term: string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    const text = String(value);
    const needle = (term ?? '').trim();
    if (!needle) {
      return HighlightPipe.escapeHtml(text);
    }

    const pattern = new RegExp(HighlightPipe.escapeRegExp(needle), 'gi');
    let result = '';
    let lastIndex = 0;
    let match: RegExpExecArray | null;
    while ((match = pattern.exec(text)) !== null) {
      result += HighlightPipe.escapeHtml(text.slice(lastIndex, match.index))
        + '<mark>' + HighlightPipe.escapeHtml(match[0]) + '</mark>';
      lastIndex = match.index + match[0].length;
    }
    result += HighlightPipe.escapeHtml(text.slice(lastIndex));

    return result;
  }

  private static escapeHtml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private static escapeRegExp(text: string): string {
    return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
}
